<mat-toolbar class="default-bg mat-elevation-z4" style="height: 78px; position: fixed;">

  <img class="logo" [style.height.px]="74" src="assets/images/header-logo.png" aria-label="Home">

  <div class="vertical-separator"></div>

  <span class="header-container"></span>

  <div class="vertical-separator"></div>
</mat-toolbar>